export const TIME_ENTRY_REPORT_PAGE = "Time Entry Report";
